/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Admin_Funnel_Card_YesterdayInputs */

const en_admin_funnel_card_yesterday = /** @type {(inputs: Admin_Funnel_Card_YesterdayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yesterday by now: ${i?.value}`)
};

/**
* | output |
* | --- |
* | "Yesterday by now: {value}" |
*
* @param {Admin_Funnel_Card_YesterdayInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_card_yesterday = /** @type {((inputs: Admin_Funnel_Card_YesterdayInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Card_YesterdayInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_card_yesterday(inputs)
});
export { admin_funnel_card_yesterday as "admin.funnel.card.yesterday" }